export const CLOSING_AGENDA_PATH = "/transaction/closing-agenda";
export const SCHEDULED_PATH = "/scheduled-meetings";
// Migrating to this path. Users that attempt to go to /scheduled-meetings
// will be redirected.
export const UPCOMING_PATH = "/meetings/upcoming";
